// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mm-c";
export var backButton = "_mm-4";
export var backIcon = "_mm-5";
export var chevronShortcut = "_mm-6";
export var container = "_mm-1";
export var editor = "_mm-8";
export var editorWrapper = "_mm-7";
export var prefix = "_mm-2";
export var searchIcon = "_mm-3";
export var suffix = "_mm-9";
export var suffixContent = "_mm-a";
export var suffixText = "_mm-b";
export var wrapper = "_mm-0";